// Imports
import { StateProvider } from './store';
import { ReactWrapper } from 'src/modules/ReactWrapper/jsx/component.jsx';
import { ReactLoader } from 'src/modules/ReactLoader/jsx/component.jsx';

import { getStorage, setStorage, deleteStorage } from 'src/lib/storage.js';



export const App = () => {

    // The origingal state that we use when we restart the app

    const originalState = {
        'globalText': null,
        'componentsData': [],
        'userData': {
            'uniqueUserID': '',
            'currentAssetID': null,
            'availableNavItems': [],
            'questionResponses': {},
            'expandedItem': null
        },
        'controlData': {
            'currentIndex': -1,
            'currentItem': null,
            'prevItem': null,
            'nextItem': null,
            'noOfQuestions': 0,
            'noOfRapidQuestions':0,
            'isLoading': false,
            'appLoaded': true,
            'hasSubmittedContent': false,
            'submittedContentString': '',
            'submittedContentStrings': []
        },
        'questionData': {},
        'questionSectionData': {},
        'modalData': {
            showModal: false,
            content: <div>test</div>,
            buttons: <div>buttons</div>,
            title: "",
            callback: null,
            additionalClass: ""
        }

    }


    // Global Initial App State
    const appState = {
        'globalText': null,
        'componentsData': [],
        'userData': {
            'uniqueUserID': '',
            'currentAssetID': null,
            'availableNavItems': [],
            'questionResponses': {},
            'expandedItem': null
        },
        'controlData': {
            'currentIndex': -1,
            'currentItem': null,
            'prevItem': null,
            'nextItem': null,
            'noOfQuestions': 0,
            'noOfRapidQuestions':0,
            'isLoading': true,
            'appLoaded': false,
            'hasSubmittedContent': false,
            'submittedContentString': '',
            'submittedContentStrings': []
        },
        'questionData': {},
        'questionSectionData': {},
        'modalData': {
            'showModal': false,
            'content': null,
            'buttons': null,
            'title': "",
            'additionalClass': ""
        },
        'submittedState': {}
    };

    var initialisedUserData = null;

    // Global variables
    var appStorageKey = 'resilianceApp';
    var flatNavArray = [];
    



    // based on the currentAsset set in .userData, return a new controlData object with the current next and previous objects.
    const getCurrentNextAndPrevious = (globalState) => {

        var newControlData = globalState.controlData;

        flatNavArray.forEach((item, index) => {
            if (item.assetID === globalState.userData.currentAssetID) {
                newControlData.currentIndex = index;
                newControlData.currentItem = flatNavArray[newControlData.currentIndex];
            }
        });

        // if theres a previous page set it otherwise set it to null
        newControlData.prevItem = newControlData.currentIndex !== 0 ? flatNavArray[newControlData.currentIndex - 1] : null;

        // if theres a next page set it otherwise set it to null
        newControlData.nextItem = newControlData.currentIndex !== flatNavArray.length - 1 ? flatNavArray[newControlData.currentIndex + 1] : null;

        //set the completed top nav items
        if (globalState.userData.availableNavItems.indexOf(newControlData.currentItem.topLevelAsset) === -1) {
            globalState.userData.availableNavItems.push(newControlData.currentItem.topLevelAsset);
        }

        // Add the top level assessment accordion to available items
        if (globalState.userData.availableNavItems.indexOf(newControlData.currentItem.assessmentId) === -1) {
            globalState.userData.availableNavItems.push(newControlData.currentItem.assessmentId);
        }

        // Make all detailed assessment sections available on first visit to the hub
        if (newControlData.currentItem.pageType === 'assessment' && newControlData.currentItem.assessmentType === 'detailed') {

            let questionSectionData = globalState.questionSectionData;
            let daQsections = Object.values(questionSectionData).filter(
                (item) => {
                    return item.assessmentType == "detailed";
                }
            )
    
            // Add detailed assessment sections to available nav items
            daQsections.forEach((section) => {
                let sectionId = section.assetID;
                if (globalState.userData.availableNavItems.indexOf(sectionId) === -1) {
                    globalState.userData.availableNavItems.push(sectionId);
                }
            });
            
        }

        return newControlData;

    }



    // creates the flat nav to go prev and next
    const createFlatNav = (array, assessment = -1, hub = -1, topLevel = -1, questionSection = -1,assessmentType = null) => {

        array.forEach((item) => {

            // we need an object to easily get the question items in the report
            if (item.pageType === 'question') {
                appState.controlData.noOfQuestions++;
                item['counterNumber'] = appState.controlData.noOfQuestions;
                appState.questionData[item.assetID] = item;
                //if a question section asset ID has been passed through set the it on the question so we know the parent for the report.
                item['parentQuestionSection'] = questionSection;
                //console.log("item.assessmentType ", item.assessmentType )
                
            }
           

            //addition for Phase 2 - we now have items contained in 2 accordions that just expand and collapse - however we need to seperate the rapid and detailed items
            if (item.pageType === 'assessment') {
                assessmentType = item.assessmentType;
                assessment = item.assetID;
                item['topLevelAsset'] = item.assetID;
                item['assessmentId'] = item.assetID;
                flatNavArray.push(item);
            }else{
                //top level page assetid used to know what to highlight in the nav
                var newTopLevel;
                if (topLevel === -1) {
                    newTopLevel = item.assetID;
                } else {
                    newTopLevel = topLevel;
                }
                item['topLevelAsset'] = newTopLevel;
                item['assessmentId'] = assessment;
                item['assessmentType'] = assessmentType;
                flatNavArray.push(item);
            }     


            if (item.pageType === 'assessment') {
                if (item.assessmentType === 'detailed') {
                    hub = item.assetID;
                }
            }

            //we need to get a counter of just the rapid questions
            if (item.pageType === 'question') {
                //if we are within an app with rapid and detailed assessments only add to the rapid questions. If assessmentType === null we are within a rapid only app
                if(item.assessmentType === 'rapid'){
                    appState.controlData.noOfRapidQuestions++;
                }else if(item.assessmentType === null){
                    appState.controlData.noOfRapidQuestions++;
                }
            }


            //if this is a question Section pass the id to the children questions
            if (item.pageType === 'questionSection') {
                questionSection = item.assetID;
                appState.questionSectionData[item.assetID] = item;

                if (item.assessmentType === 'detailed') {
                    item['hubId'] = hub;
                }
            }

            //if we are on the homepage we need to store the select items within the user question data
            if (item.pageType === 'homePage') {
                if(typeof(item.homeSelectItems) !== 'undefined'){
                    if(item.homeSelectItems.length !== 0){
                        item.homeSelectItems.forEach((homeSelectItem) => {
                            appState.questionData[homeSelectItem.assetID] = homeSelectItem;
                        })
                    
                    }
                }
            }
            

            if (item.children) {
                createFlatNav(item.children, assessment, hub, newTopLevel, questionSection,assessmentType);
            }
        });
    }

    // set the user data to the next item, set local storage and return the current previous and next items.
    const advanceProgress = (globalState) => {    
        if (globalState.controlData.nextItem !== null) {
            globalState.userData.currentAssetID = globalState.controlData.nextItem.assetID;

            // Expand next assessment section
            if (globalState.controlData.nextItem.assessmentId !== null) {
                globalState.userData.expandedItem = globalState.controlData.nextItem.assessmentId;
            }
        }
        setStorage('local', appStorageKey, globalState.userData);
        return getCurrentNextAndPrevious(globalState);
    }

    //sets the current asset to the previous asset 
    const retreatProgress = (globalState) => {
        if (globalState.controlData.prevItem !== null) {
            globalState.userData.currentAssetID = globalState.controlData.prevItem.assetID;

            // Expand previous assessment section
            if (globalState.controlData.prevItem.assessmentId !== null) {
                globalState.userData.expandedItem = globalState.controlData.prevItem.assessmentId;
            }
        }

        setStorage('local', appStorageKey, globalState.userData);
        return getCurrentNextAndPrevious(globalState);
    }

    // sets the current asset to the passed assetID - used when selecting Progression Nav items
    const setProgress = (assetID, globalState) => {
        globalState.userData.currentAssetID = assetID;
        setStorage('local', appStorageKey, globalState.userData);
        return getCurrentNextAndPrevious(globalState);
    }

    // sets the current asset to the passed assetID of an assessment page, and expands the Nav accordingly
    const setProgressToAssessment = (assetID, globalState) =>{
        globalState.userData.expandedItem = assetID; // Expand the assessment section
        globalState.userData.currentAssetID = assetID;
        setStorage('local', appStorageKey, globalState.userData);
        return getCurrentNextAndPrevious(globalState);
    }

    // sets the answer in the user data as a map with current asset id as the key and the passed userResponse as the value
    const setAnswer = (userResponse, globalState) => {
        let newUserData = globalState.userData;
        newUserData.questionResponses[globalState.userData.currentAssetID] = userResponse;
        setStorage('local', appStorageKey, newUserData);
        return newUserData;
    }

    // sets the answer in the user data as a map with both the key and value provided
    const setAnswerAtKey = (userResponse, globalState) => {
        let newUserData = globalState.userData;
        newUserData.questionResponses[userResponse.key] = userResponse.value;
        setStorage('local', appStorageKey, newUserData);

        return newUserData;
    }

    // sets the show modal option in modal data so the modal is shown
    const showModal = (globalModalData) => {
        let newModalData = globalModalData;
        newModalData.showModal = true;
        return newModalData;
    }

    // sets the show modal option in modal data so the modal is hidden
    const hideModal = (globalModalData) => {
        let newModalData = globalModalData;
        newModalData.showModal = false;
        newModalData.wideModal = false;
        return newModalData;
    }

    // toggles the show modal option in modal data 
    const toggleModal = (globalModalData) => {
        let newModalData = globalModalData;

        if (newModalData.showModal) {
            newModalData.showModal = false;
            newModalData.wideModal = false;
        } else {
            newModalData.showModal = true;
        }

        return newModalData;
    }

    // returns the modal data to show modal loading when user submits Email Report Modal
    const showModalEmailLoading = (state) => {
        let newModalData = state.modalData;

        newModalData.content = <>
            <ReactLoader />
            <p>{state.globalText.modalEmailLoading}</p>
        </>
        newModalData.buttons = [];
        return newModalData;
    }

    // returns the modal data to show modal when user submits Email is successful
    const showModalEmailSuccess = (state) => {
        let newModalData = state.modalData;
        newModalData.content = <>
            <p>{state.globalText.modalEmailSuccess}</p>
        </>
        newModalData.buttons = [{ class: "br-app-btn", label: state.globalText.modalEmailBtnSuccess }];
        return newModalData;
    }

    // returns the modal data to show modal when user submits Email has failed
    const showModalEmailFail = (state) => {
        let newModalData = state.modalData;
        newModalData.content = <>
            <p>{state.globalText.modalEmailFail}</p>
        </>
        newModalData.buttons = [{ class: "br-app-btn", label: state.globalText.modalEmailBtnFailure }];
        return newModalData;
    }

    // returns the modal data to show the Detailed Assessment Report
    const showModalDetailedAssessmentReport = (state, modalContent) => {
        let newModalData = showModal(state.modalData);
        newModalData.title = state.globalText.detailedReportTitle;
        newModalData.wideModal = true;
        newModalData.content = modalContent;
        newModalData.buttons = [];
        newModalData.additionalClass = "appModal__detailedReport";
        return newModalData;
    }

    // returns the modal data to show the confirm Restart Modal on Restart or from Report page
    const showConfirmRestart = (state, callback) => {
        let newModalData = showModal(state.modalData);
        newModalData.title = state.globalText.modalConfirmRestartTitle;
        newModalData.content = <> <p>{state.globalText.modalConfirmRestartContent}</p> </>;

        newModalData.buttons = [{ action: 'custom', clickHandler: () => { callFunction(callback) }, class: "br-app-btn", label: state.globalText.modalConfirmRestartBtnConfirm }, { class: "br-app-btn", label: state.globalText.modalConfirmRestartBtnReject }];

        return newModalData;
    }

    const callFunction = (callback) => {
        callback.call();
    }

    // returns the modal data to show an Error Modal when data is invalid
    const userDataErrorModal = (state) => {
        let newModalData = showModal(state.modalData);
        newModalData.title = state.globalText.modalDataErrorTitle;
        newModalData.content = <> <p>{state.globalText.modalDataErrorContent}</p> </>

        newModalData.buttons = [{ class: "br-app-btn", label: state.globalText.modalDataErrorBtnContinue }];

        return newModalData;
    }

    // adds classes to fade in the report
    const toggleFadeInContents = (controlData) => {
        if (controlData.currentItem.pageType === 'report') {
            document.querySelector('.br-app-main-content__contents').classList.add('fade-in-contents');
        } else {
            document.querySelector('.br-app-main-content__contents').classList.remove('fade-in-contents');
        }
    }

    var isKeyBoardNavigating = false;

    const initCheckIfKeyboardUser = () =>{
        document.addEventListener("keydown", handleKeyboardNav, false);
        
    }
    
    const handleMouseNav = (e) => {
        // in react pressing enter on a button fires a synthetic event.
        // e.detail === 0 means this is a enter button press not a mouse click
        // https://github.com/facebook/react/issues/3907
        if(e.detail !== 0){
        // e.preventDefault();
            if(isKeyBoardNavigating !== false ){
                document.removeEventListener("click", handleMouseNav, false);
                isKeyBoardNavigating = false;        
            }            
        }
    }

    // Listen for a keyboard press to track if user is navigating with keyboard  
    const handleKeyboardNav = (e) => {
        
       // e.preventDefault();
        if (e.keyCode === 9 || e.keyCode === 13) {
            if(isKeyBoardNavigating !== true ){
                document.addEventListener("click", handleMouseNav, false);
                isKeyBoardNavigating = true;
            }   
        }else{
            if(isKeyBoardNavigating !== false ){
                document.removeEventListener("click", handleMouseNav, false);
                isKeyBoardNavigating = false;
            }
        }       
    }

    const handleFocusOnPageIndexChange = () => {
        if(isKeyBoardNavigating == true){
            var firstBtn = document.querySelector('.br-app-main-content__input-group .br-app-btn:first-child');
            if(typeof firstBtn !== 'undefined' && firstBtn !== null) {
                document.querySelector('.br-app-btn').focus()
            }
        }
    }
    
    const scrollToTopOfApp = () => {
        //window.scrollTo({ top: 0 });
        // scroll to the top of the main container
        var reactTop = document.querySelector('#react__app-wrapper-content').getBoundingClientRect().top;
        if(reactTop <= 0){
            window.scrollTo({top: reactTop + window.pageYOffset - 5})
        }
    }

    // reducer for the state
    const reducer = (state, action) => {
        let newControlData, newGlobalText, newComponentsData, newUserData, newModalData;


        switch (action.type) {
            case 'dataLoaded':
               
                var appData = action['value'];
                // Map state
                newGlobalText = state['globalText'];
                newComponentsData = state['componentsData'];
                newControlData = state['controlData'];
                newUserData = state['userData'];
                newModalData = state['modalData'];

                
                // Update app data
                newGlobalText = appData['globalText'];
                newComponentsData = appData['componentsData'];
                newUserData['currentAssetID'] = newComponentsData[0]['assetID'];

                appStorageKey = appData['globalText']['localStorageKey'];

                // Check for data overrides
                newUserData = fastForwardProgress(newUserData);

                // Check for in progress submission
                newModalData = buildDataFromLocalStorage(newModalData, newGlobalText);

                // Update loading states
                newControlData['appLoaded'] = true;
                newControlData['isLoading'] = false;

                initCheckIfKeyboardUser();
                
                return {
                    ...state,
                    globalText: newGlobalText,
                    componentsData: newComponentsData,
                    controlData: newControlData,
                    userData: newUserData,
                    modalData: newModalData
                }

            case 'appInit':
                // App is no longer in a loading state
                // Init the app data and render

                // Create the flat nav used for navigating 
                //flatNavArray
                createFlatNav(state['componentsData']);

                //set a unique id on the users first visit, we use this to filter results sent to matrix for form submissions
                if(state.userData.uniqueUserID == ''){
                    state.userData.uniqueUserID = Math.floor(Math.random() * 1000000000);
                }


                // Update user position

                newUserData = state.userData;
                newModalData = state.modalData;
                try {
                    newControlData = getCurrentNextAndPrevious(state);
                } catch (e) {

                    let noOfQuestions = state.controlData.noOfQuestions
                    state.controlData = originalState.controlData;
                    state.controlData.noOfQuestions = noOfQuestions;
                    state.controlData.currentItem = flatNavArray[0];
                    state.controlData.currentIndex = 0;
                    state.userData = originalState.userData;
                    newUserData = originalState.userData;
                     //set a unique id on the users first visit, we use this to filter results sent to matrix for form submissions
                    if(newUserData.uniqueUserID == ''){
                        newUserData.uniqueUserID = Math.floor(Math.random() * 1000000000);
                    }
                    newModalData = userDataErrorModal(state);

                    newControlData = getCurrentNextAndPrevious(state);
                }

                

                return {
                    ...state,
                    userData: newUserData,
                    modalData: newModalData,
                    controlData: newControlData
                }

            case 'mainNavClick':

                let assetID = action.value.assetID;
                newControlData = setProgress(assetID, state);
                //window.scrollTo({ top: 0 });
                scrollToTopOfApp()

                toggleFadeInContents(newControlData);

                return {
                    ...state,
                    controlData: newControlData
                }

            case 'mainNavClick_assessment':

                let assetID_assessment = action.value.assetID;
                newControlData = setProgressToAssessment(assetID_assessment,state)
                //window.scrollTo({ top: 0 });
                scrollToTopOfApp();

                toggleFadeInContents(newControlData);

                return {
                    ...state,
                    controlData: newControlData
                }

            // when prev or next is clicked in the footer
            case 'footerNavClick':
                
                if (action.value === "prev") {
                    newControlData = retreatProgress(state);
                } else if (action.value === "next") {
                    newControlData = advanceProgress(state);
                }
                scrollToTopOfApp()
                
                

                
                toggleFadeInContents(newControlData);

                return {
                    ...state,
                    controlData: newControlData
                }

            // when an answer is selected in a question
            case 'answerSelected':
                return {
                    ...state,
                    userData: setAnswer(action.value.userResponse, state)
                }

            case 'sliderValueUpdated':
                return {
                    ...state,
                    userData: setAnswerAtKey(action.value.userResponse, state)
                }

            case 'homeOptionSelected':
                return {
                    ...state,
                    //userData: setHomeResponse(action.value.userResponse, state)
                    userData: setAnswerAtKey(action.value.userResponse, state)
                }

            case 'modalToggleClick':
                newModalData = toggleModal(state['modalData']);

                return {
                    ...state,
                    modalData: newModalData
                }

            case 'restart':
               // console.log("restarting")
                deleteStorage('local', appStorageKey);                
                newUserData = appState.userData;

                //reset the things needing reset
                newUserData.availableNavItems = [];
                newUserData.questionResponses = {};
                newUserData.expandedItem = "";
                 //set a unique id on the users first visit, we use this to filter results sent to matrix for form submissions
                 if(newUserData.uniqueUserID == ''){
                    newUserData.uniqueUserID = Math.floor(Math.random() * 1000000000);
                }

              //  console.log(newUserData)
                newUserData['currentAssetID'] = state.componentsData[0]['assetID'];

                newControlData = getCurrentNextAndPrevious(appState);

                window.scrollTo({ top: 0 });
                newModalData = hideModal(state['modalData'])




                return {
                    ...state,
                    userData: newUserData,
                    controlData: newControlData,
                }

            case 'showConfirmRestartModal':
                newModalData = showConfirmRestart(state, action.callback);

                return {
                    ...state,
                    modalData: newModalData
                }



            case 'emailSendLoading':
                newModalData = showModalEmailLoading(state);

                return {
                    ...state,
                    modalData: newModalData
                }

            case 'emailSendSuccess':
                newModalData = showModalEmailSuccess(state);

                return {
                    ...state,
                    modalData: newModalData
                }

            case 'emailSendFail':
                newModalData = showModalEmailFail(state);

                return {
                    ...state,
                    modalData: newModalData
                }

            case 'showProgressReportModal':
                newModalData = showModalDetailedAssessmentReport(state, action.value.modalContent);

                return {
                    ...state,
                    modalData: newModalData
                }

            case 'clearStorage':
                // Delete storage object
                deleteStorage('local', appStorageKey);

            case 'userDataSubmitted':
                newControlData = state['controlData'];
                newControlData.hasSubmittedContent = true;
                //newControlData.submittedContentStrings = action.value;
                //newControlData.submittedContentStrings.push(action.value);                
                newControlData.submittedContentStrings.push(newControlData.submittedContentString);
                return {
                    ...state,
                    controlData: newControlData
                }
            case 'pageIndexChangeRendered':
                handleFocusOnPageIndexChange();
                
                return state;
            default:
                return state;
        }
    }

    //returns the user data based on various variables
    const fastForwardProgress = (globalUserData) => {
        //check if there is a queryString eg. user has returned from email
        if (userIsReturningFromEmailURL() === true) {
            return buildDataFromQueryParams();
        }

        // Check storage for existing progress
        var local_progress = getStorage('local', appStorageKey);

        if (local_progress !== null) {
            return JSON.parse(local_progress);
        }

        // Return defaults if no overrides
        return globalUserData;
    };

    //returns a specific URL parameter from the passed name
    const getUrlParameter = (name) => {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    //check if the user is returning from the link we send to the via email
    const userIsReturningFromEmailURL = () => {
        return getUrlParameter('return') === 'email';
    }

    //check query params to see if we need to build for a returning user
    const buildDataFromQueryParams = () => {
        // Example querystring as built by buildEmailLink()
        // ?a=12345&b=1,2,12,12aa,12345&c=1234a_2,1234b_2,1234aaa_1,1234aab_1

        //user data objects: 
        //currentAssetID    == current
        //uniqueUserID == uuid
        //expandedItem == ei
        //availableNavItems == b
        //questionResponses == c

        var query = window.location.search.slice(1);
        var pairs = query.split('&');
        var result = {};

        pairs.forEach((p) => {
            var item = p.split('=');
            var key = item[0];
            var value = decodeURIComponent(item[1] || '');

            //set the current asset
            if (key === 'current') {
                result['currentAssetID'] = value;

            //set the unique user id  
            } else if(key === 'uuid'){
                result['uniqueUserID'] = value;
            
            //set the expanded item
            }else if(key === 'ei'){    
                result['expandedItem'] = value;

                // set the available progression nav items
            } else if (key == 'b') {
                //turn query into array object b=123,321
                let valArrayNavItems = value.split(",");
                result['availableNavItems'] = valArrayNavItems;

                //set the users answers responses
            } else if (key === 'c') {
                let responseObject = {};
                let valArrayResponses = value.split(",");
                valArrayResponses.forEach((response) => {
                    var responseArr = response.split('_');
                    var responseKey = String(responseArr[0]);
                    var responseVal = Number(responseArr[1]);
                    // test for responses that may be strings
                    // added in phase 2 to handle home selects
                    if(Number.isNaN(responseVal)){
                        responseVal = String(responseArr[1]);
                    }
                    responseObject[responseKey] = responseVal;
                })
                result['questionResponses'] = responseObject;
            }

        })

        return result;
    }

    // if we are not returning from Email URL, check local storage for progression
    const buildDataFromLocalStorage = (globalModalData, globalText) => {

        // if we are not returning via the email URL
        if (userIsReturningFromEmailURL() !== true) {
            // Check storage for existing progress
            var local_progress = getStorage('local', appStorageKey);
            if (local_progress !== null) {
                // Set up progression modal
                var modal_title = globalText.modalRestartTitle;
                var modal_content = <p>{globalText.modalRestartDescription}</p>;
                var modal_buttons = [{
                    'class': "br-app-btn",
                    'label': globalText.modalRestartBtnLabelContinue
                }, {
                    'action': 'custom',
                    'clickHandler': 'restart',
                    'class': "br-app-btn",
                    'label': globalText.modalRestartBtnLabelRestart
                }];

                return {
                    'showModal': true,
                    'content': modal_content,
                    'buttons': modal_buttons,
                    'title': modal_title
                };
            }
        }

        // Return itself if no local data
        return globalModalData;

    }
    

    // Render
    return (
        <StateProvider appState={appState} reducer={reducer}  >
            <ReactWrapper />
        </StateProvider>
    );
}
